import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { InfiniteScrollLoaderContainer } from '@/components/InfiniteScrollLoader/InfiniteScrollLoaderContainer'
import { FirmDashboardJobsTable } from '@/features/jobs/dashboard/components/FirmDashboardJobsTable'
import { FirmDashboardJobsTableRowContainer } from '@/features/jobs/dashboard/components/FirmDashboardJobsTableRow/FirmDashboardJobsTableRowContainer'
import { type FirmDashboardJobTableViewModel } from '@/features/jobs/dashboard/FirmDashboardJobTableViewModel'

export interface FirmDashboardJobsTableContainerProps {
  vm: FirmDashboardJobTableViewModel
}

export const FirmDashboardJobsTableContainer = observer(
  function FirmDashboardJobsTableContainer({
    vm,
  }: FirmDashboardJobsTableContainerProps) {
    const { shellInfo } = useFeatures(({ shell }) => ({
      shellInfo: shell.shellInfo,
    }))
    return (
      <FirmDashboardJobsTable
        showEmptyView={vm.showEmptyView}
        columns={vm.columnsVm.filteredColumns
          .filter((col) => col.visible)
          .map((col) => ({
            id: col.id,
            header: col.header,
            canSort: col.sortable,
            sortOrder: vm.getSortOrder(col),
            onSort: (newSort) => vm.setSortOrder(col, newSort),
          }))}
        scrollLoader={
          <InfiniteScrollLoaderContainer
            scrollProvider={vm.searcher.scroller}
          />
        }
        onClearSearchFilter={vm.searcher.clearFilters}
        corporateMode={shellInfo.corporateMode}
      >
        {vm.filteredJobs.map((job) => (
          <FirmDashboardJobsTableRowContainer vm={vm} job={job} key={job.id} />
        ))}
      </FirmDashboardJobsTable>
    )
  },
)
